/*
 * @Descripttion:
 * @version:
 * @Author: ared
 * @Date: 2022-10-27 14:46:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-20 10:16:41
 */
// @flow
import * as React from "react";
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import { useState,useEffect } from "react";
import { goodsVideoData, productVideoData } from "@home3/homeType";
import GoodsBox from "./goodsBox";
import ProductBox from "./productBox";
import { handleToMoblieList, handleToUrl } from "@/utils/sys";
import { Carousel } from "antd";
import { getGoodsVideoList } from "@/service";

type Props = {
    // productData: productVideoData[];
    // goodsVideoData: goodsVideoData[];
};

const Index = (props: Props) => {
    const { t, i18n } = useTranslation("home");
    // const { productData, goodsVideoData } = props;
    const [productData, setProductData] = useState([])
    const [goodsVideoData, setgoodsVideoData] = useState([])
    let [curIndex, setCurIndex] = useState(0);
    const handClick = (suburl: string) => {
        // handleToMoblieList("Videos", suburl);
        // handleToUrl("/mobile/videos/" + suburl);
        window.location.href =
            process.env.mobileUrl +
            "/rank?type=Videos&rankType=breakout";
    };





    useEffect(() => {
        //   first
        if(process.browser){
        const fetchData = async () => {
            let goodsVidoe = await getGoodsVideoList({});
            // let goodsVideoData = [];
            // let productData: any = [];
            if (goodsVidoe && goodsVidoe.code == 0) {
                setProductData(goodsVidoe?.data?.productVideoRank)
                setgoodsVideoData(goodsVidoe?.data?.goodsVideoRank)
                // goodsVideoData = goodsVidoe?.data?.goodsVideoRank;
                // productData = goodsVidoe?.data?.productVideoRank;
            }
              }
            fetchData()    
        }
    
          return () => {}
        }, [])


    return (
        <div className={`${styles.video}`}>
            <div className={`${styles.container}`}>
                <div className={styles.tap}>
                    <ul>
                        <li>
                            <a
                                style={{
                                    color:
                                        curIndex === 0
                                            ? "#2E384E"
                                            : "rgba(46,56,78,0.4600)",
                                }}
                                onClick={() => setCurIndex(0)}
                            >
                                {t("Products Video")}
                                <div
                                    className={styles.bar}
                                    style={{
                                        display: curIndex !== 0 ? "none" : "",
                                    }}
                                ></div>
                            </a>
                        </li>
                        <li>
                            {/* <a
                                style={{
                                    marginLeft: "calc(100vw * (20 / 375))",

                                    color:
                                        curIndex === 0
                                            ? "rgba(46,56,78,0.4600)"
                                            : "#2E384E",
                                }}
                                onClick={() => setCurIndex(1)}
                            >
                                {t("productVideoRank")}
                                <div
                                    className={styles.bar}
                                    style={{
                                        display: curIndex === 0 ? "none" : "",
                                    }}
                                ></div>
                            </a> */}
                        </li>
                    </ul>
                    <div
                        className={styles.more}
                        onClick={() =>
                            handClick(curIndex === 0 ? "products" : "promotion")
                        }
                    >
                        {t("more")}
                    </div>
                </div>
                <div className={styles.itemTitle2}>{t("videoUpdate6")}</div>
                <div className={styles.main}>
                    {curIndex == 0 ? (
                        <GoodsBox data={goodsVideoData} />
                    ) : (
                        <ProductBox data={productData} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Index;
